import styled from "styled-components";
import colors from "../../styles/colors";

export const Container = styled.div``;

export const ValorInvalido = styled.div`
  font-weight: bold;
  color: ${colors.tableColors.headerText};
`;

export const ParcelamentoContainer = styled.div`
  display: flex;
  margin: 10px 0;
  label {
    font-size: 13px;
    font-weight: bold;
    margin-right: 15px;
  }
`;

export const ParcelamentoLabel = styled.label`
  span {
    display: block;
    margin-bottom: 4px;
  }
  select {
    padding: 4px 6px;
    background-color: transparent;
    border-radius: 4px;
  }
`;

export const ParcelamentoTableHead = styled.thead`
  background-color: ${colors.tableColors.header};
  color: ${colors.tableColors.headerText};
  th {
    padding: 8px 10px;
    font-weight: 600;
    letter-spacing: 0.3px;
  }
`;

export const ParcelamentoTableBody = styled.tbody`
  text-align: center;
  td {
    padding: 8px 10px;
    border-bottom: 1px solid ${colors.tableColors.border};
    transition: background-color 0.2s ease;
  }

  tr:hover td {
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

export const ParcelamentoEspecialToggle = styled.div`
  margin: 8px 0 12px;

  input {
    margin: 0 5px;
    cursor: pointer;
  }

  label {
    cursor: pointer;
  }
`;
